/* eslint-disable */
import React, { useEffect, useState } from "react";
import { utility } from "../../framework/utility/utilityProvider";
import * as API from "../../framework/API/api";
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, PLAN_EVENT_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import ToastNotification from "../../components/ToastNotification";
import MyMultiSelect from "../../components/MyMultiSelect";

const PlanningBrowser = () => {
    const lang = useTranslation();
    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const blankDataItem = {
        FromDate: defaultDates.FirstDate,
        ToDate: defaultDates.LastDate,
        Channels: [],
        EventType: { _id: PLAN_EVENT_TYPE.All, Description: utility.getKeyByValue(PLAN_EVENT_TYPE, PLAN_EVENT_TYPE.All) }
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [eventTypes, setEventTypes] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [isMinified, setIsMinified] = useState(utility.getValue(LOCALSTORAGE_KEY.isMenuMified));
    const [selectAllChannels, setSelectAllChannels] = useState(false);

    useEffect(() => { loadCombo() }, [])

    const loadCombo = async () => {
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels(channelRes.data);
        const eventTypeRes = Object.keys(PLAN_EVENT_TYPE).map((x) => {
            return {
                _id: PLAN_EVENT_TYPE[x],
                Description: x
            }
        })
        setEventTypes(eventTypeRes);
    }
    const onChange = (e) => {
        if (e.target.name == "IsAllChannel") {
            setSelectAllChannels(!selectAllChannels);
            setDataItem({ ...dataItem, Channels: selectAllChannels ? [] : channels });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value })
        }
    };

    const isValid = () => {
        if (!utility.isValidDate(dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItem.ToDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.ToDate < dataItem.FromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        if (!dataItem.Channels || dataItem.Channels.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        return true
    }

    const loadData = async () => {

        if (!isValid()) return;
        setGridData([]);
        setLoadingStatus(lang.data_loading_error_message);

        const finalData =
        {
            FromDate: dataItem?.FromDate ? utility.convertStringDatetoMilliseconds(dataItem.FromDate) : null,
            ToDate: dataItem?.ToDate ? utility.convertStringDatetoMilliseconds(dataItem.ToDate) : null,
            ChannelSID: dataItem?.Channels?.length > 0 ? dataItem?.Channels?.map((x) => x.SID) : [],
            EventTypeID: dataItem?.EventType?._id,
            isDownload: false
        };
        const res = await API.getPlanningBrowser(finalData);

        console.log(res.data);
        if (res.success) {
            if (!res.data?.length) {
                setGridData([]);
                setLoadingStatus(lang.no_record_found_error_message);
                return;
            }
            const sortedData = res.data.sort((a, b) => {
                if (a.ScheduleDate === b.ScheduleDate) {
                    return a.SlotDateTime - b.SlotDateTime;
                }
                return a.ScheduleDate - b.ScheduleDate;
            });
            setGridData(sortedData);
            setLoadingStatus(lang.data_load_successfully_message);

        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setGridData([]);
            setLoadingStatus(lang.no_record_found_error_message);
        }
    };

    const downloadExcel = async () => {

        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_record_found_error_message });
            return;
        }
        const finalData =
        {
            FromDate: dataItem?.FromDate ? utility.convertStringDatetoMilliseconds(dataItem.FromDate) : null,
            ToDate: dataItem?.ToDate ? utility.convertStringDatetoMilliseconds(dataItem.ToDate) : null,
            ChannelSID: dataItem?.Channels?.length > 0 ? dataItem?.Channels?.map((x) => x.SID) : [],
            EventTypeID: dataItem?.EventType?._id,
            isDownload: true
        };
        const res = await API.getPlanningBrowser(finalData);
        console.log(res.data);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const StatusCell = (props) => {
        const { field, dataItem } = props;
        const value = dataItem[field];

        if (!value) return <td></td>;

        let style = {};

        if (field === "IsCatchUp" && value === true) {
            style = { padding: "6px 35px 6px 35px", backgroundColor: "red", borderRadius: '4px', textAlign: "center", color: "white", fontWeight: "normal", fontSize: "12px", verticalAlign: "center", fontFamily: "Roboto", letterSpacing: "0.6px", margin: "0px", userSelect: "none", pointerEvents: "none" };
        }
        if (field === "IsBlackOut" && value === true) {
            style = { padding: "6px 50px 6px 50px", backgroundColor: "black", borderRadius: '4px', textAlign: "center", color: "white", fontWeight: "normal", fontSize: "12px", verticalAlign: "center", fontFamily: "Roboto", letterSpacing: "0.6px", margin: "0px", userSelect: "none", pointerEvents: "none" };
        }
        return (<td> <span style={style}>{field === "IsCatchUp" ? "CatchUp" : "YES"}</span> </td>);
    };

    const DurationCell = (props) => {
        const dataItem = props.dataItem;
        const duration = dataItem?.customDuration && dataItem.customDuration > 0 ? dataItem.customDuration : dataItem?.mediaEpisode?.Duration;
        return (<td> {duration ? utility.convertMilisecondsToStringWithFrames(duration) : ""} </td>);
    };

    const DayCell = (props) => (
        <td>{props?.dataItem?.ScheduleDate ? new Date(props?.dataItem?.ScheduleDate).toLocaleDateString("en-US", { weekday: "long" }) : ""}</td>
    );
    const DateCell = (props) => (
        <td> {props?.dataItem?.ScheduleDate ? new Date(props?.dataItem?.ScheduleDate).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" }) : ""}</td>
    );
    const TimeCell = (props) => {
        return (
        <td> {props?.dataItem?.SlotDateTime ? new Date(props?.dataItem?.SlotDateTime).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false }) : ""}</td>
        )
    };

    return (
        <>
            <h1 className="page-title txt-color-bludeDark">
                <i
                    className="fa fa-table marlr"
                    style={{ fontSize: "20px", color: "GrayText" }}
                ></i>
                <span>{lang.planning_browser_header}</span>
            </h1>
            <div className="row m-1">
                <div className="col-12">
                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="TabView">{lang.from_date_label} *</label>
                                    <input className="form-control form-control-sm" name="FromDate" type="date" value={dataItem.FromDate} onChange={onChange} />
                                </div>
                                <div className="col-6">
                                    <label htmlFor="TabView">{lang.to_date_label} *</label>
                                    <input className="form-control form-control-sm" type="date" name="ToDate" value={dataItem.ToDate} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.channel_label} *</label>
                            <span className="float-right">{lang.select_all_label}
                                <input
                                    type="checkbox"
                                    name="IsAllChannel"
                                    className="ml-1"
                                    value={selectAllChannels}
                                    checked={selectAllChannels}
                                    onChange={onChange}
                                    style={{ marginTop: '3px' }}
                                />
                            </span>
                            <MyMultiSelect
                                style={{ backgroundColor: "white" }}
                                data={channels}
                                name="Channels"
                                textField="FullChannelName"
                                dataItemKey="_id"
                                value={dataItem.Channels}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-4">
                            <div className="row">
                                <div className="col-6">
                                    <label>{lang.event_type_label} </label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={eventTypes}
                                        name="EventType"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.EventType}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-6 mt-4" style={{ marginLeft: "-22px" }}>
                                    <ActionButton name={lang.show_button_text} onClick={loadData} />
                                    <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            {/* <Grid data={gridData} style={{ height: "65vh" }} resizable={true}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <Column field="ScheduleDate" title={lang.date_column} cell={DateOnlyCell} width={200} />
                                <Column field="SlotDateTime" title={lang.time_column} cell={TimeCell} width={170} />
                                <Column field="Duration" title={lang.duration_column} cell={DurationCell} width={200} />
                                <Column field="Channel.FullChannelName" title={lang.channel_column} width={200}/>
                                <Column field="mediaEpisode.Title" title={lang.title_column} width={200} />
                                <Column field="mediaEpisode.EpisodeTitle" title={lang.episode_title_column} width={200} />
                                <Column field="IsCatchUp" title={lang.catchup_up_column} cell={StatusCell} width={150} />
                                <Column field="IsBlackOut" title={lang.black_out_column} cell={StatusCell} width={150} />
                                <Column field="mediaEpisode.EpisodeNumber" title={lang.episode_number_column} width={120} />
                                <Column field="mediaEpisode.Genres" title={lang.genre_label} format='Description' cell={ArrayCell} width={150} />
                                <Column field="mediaEpisode.SubGenres" title={lang.sub_genre_label} format='Description' cell={ArrayCell} width={150} />
                            </Grid> */}

                            <Grid data={gridData} style={{ height: "65vh" }} resizable={true}>
                                <GridNoRecords>{loadingStatus}</GridNoRecords>
                                <Column title={lang.day_column} cell={DayCell} width={120} />
                                <Column field="ScheduleDate" title={lang.date_column} cell={DateCell} width={80} />
                                <Column field="SlotDateTime" title={lang.time_column} cell={TimeCell} width={80} />
                                <Column field="mediaEpisode.Title" title={lang.title_column} width={250} />
                                <Column field="" title={lang.commentary_column} width={150} />
                                <Column field="Channel.FullChannelName" title={lang.channel_column} width={180} />
                                <Column field="TXStatus.Description" title={lang.type_column} width={120} />
                                <Column field="" title={lang.on_air_studion_column} width={140} />
                                <Column field="" title={lang.off_air_studion_column} width={140} />
                                <Column field="Comment" title={lang.notes_column} width={200} />
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
            <div className={isMinified ? "scheduleFooter scheduleFooterMinified" : "scheduleFooter"}>
                <div className="flex-container-reverse flex-item-auto p-2">
                    <div className="footerText">{loadingStatus}</div>
                </div>
            </div>
        </>
    );
};
export default PlanningBrowser;